/* istanbul ignore file */
import gql from 'graphql-tag';

export default gql`
  mutation createCustomerBoard(
      $createCustomerBoardInput: CreateCustomerBoardInput!
    ) {
    createCustomerBoard(
        createCustomerBoardInput: $createCustomerBoardInput
    ) {
        id
        name
        curationStatus {
            id
            title
        }
        boardAssets {
            id
            sortOrder
            asset {
                id
                assetTypeId
                url
                subStyles {
                    id
                    assetId
                    subStyleId
                }
            }
        }
        boardProducts(definite:true) {
            id
            sortOrder
            vendorVariant {
                id
                image {
                    id
                    uri
                }
            }
        }
    }
}
`;
